import React, {useEffect, useState} from 'react'
import {useFormik} from 'formik'
import {TextInput} from '../../../../components/inputs/TextInput'
import {useNavigate} from 'react-router-dom'
import {createGroupeLIBPR, editGroupeLIBPR} from '../../../../components/requests'
import SelectPieces from "../../remise/components/SelectPieces";

const validate = (values) => {
  const errors: { libelle?: string, typePieces?: any, description?: string } = {}

  if (!values?.libelle) errors.libelle = 'Le libellé est requis'
  if (values?.typePieces?.length === 0) errors.typePieces = 'Les pieces sont requis'
  if (!values?.description) errors.description = 'La description est requis'

  return errors
}

const GroupeLIBPRForm = ({id, data}) => {
  const navigate = useNavigate()
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [typePiece, setTypePiece] = useState<any>([])

  // Charger les données pour la modification
  useEffect(() => {
    if (data !== null) {
      formik.setFieldValue('libelle', data.libelle)

      const typePiecesData = data.typePieces?.map((typePiece) => ({
        value: typePiece?.id,
        label: typePiece?.nom
      }))
      formik.setFieldValue('typePieces', typePiecesData)
      setTypePiece(typePiecesData)

      formik.setFieldValue('description', data.description)
    }
  }, [data])

  // Gestion des pièces excluses du frais de transport offert
  const handleSelect = (newValue: any) => {
    setTypePiece(newValue)
    formik.setFieldValue('typePieces', newValue)
  }

  const formik = useFormik({
    initialValues: {
      libelle: data?.libelle ?? '',
      typePieces: data?.typePieces?.map((typePiece) => ({
        value: typePiece?.id,
        label: typePiece?.nom
      })) ?? '',
      description: data?.description ?? ''
    },
    enableReinitialize: true,
    validate,
    onSubmit: (values) => {
      setIsLoading(true)
      const typePiecesData = values.typePieces?.map((piece) => ({
        id: piece.value,
        nom: piece.label
      }))
      let action = (data === null)
        ? createGroupeLIBPR(values.libelle, typePiecesData, values.description)
        : editGroupeLIBPR(id, values.libelle, typePiecesData, values.description)
      action
        .then((response) => {
          if (response?.data !== undefined && response?.status === 200) {
            navigate('/groupe-libpr/liste')
          }
        })
        .catch(() => console.error('erreur'))
        .finally(() => setIsLoading(false))
    },
  })

  return (
    <div>
      <form onSubmit={formik.handleSubmit} noValidate className='form'>
        <div className='card-body border-top p-9'>
          <div className='row mb-6'>
            <label className='col-lg-4 col-form-label required fw-bold fs-6'>Libellé</label>
            <div className='col-lg-8'>
              <div className='row'>
                <div className='col-lg-6 fv-row'>
                  <TextInput
                    fieldName={'libelle'}
                    inputPlaceholder={'Libellé'}
                    inputType={'text'}
                    inputClassName={'form-control form-control-lg form-control-solid mb-3 mb-lg-0'}
                    formik={formik}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className='row mb-6'>
            <label className='col-lg-4 col-form-label required fw-bold fs-6'>Type pièce</label>
            <div className='col-lg-8'>
              <div className='row'>
                <div className='col-lg-6 fv-row'>
                  <SelectPieces onSelect={handleSelect} selectedValues={typePiece} />
                  {(formik.errors.typePieces && typeof formik.errors.typePieces === 'string') && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>{formik.errors.typePieces}</div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className='row mb-6'>
            <label className='col-lg-4 col-form-label required fw-bold fs-6'>Description</label>
            <div className='col-lg-8'>
              <div className='row'>
                <div className='col-lg-6 fv-row'>
                  <textarea
                    className={'form-control form-control-lg form-control-solid mb-3 mb-lg-0'}
                    placeholder='Description'
                    cols={15}
                    rows={5}
                    {...formik.getFieldProps('description')}
                  ></textarea>
                  {(formik.errors.description && typeof formik.errors.description === 'string') && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>{formik.errors.description}</div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className='card-footer d-flex justify-content-end py-6 px-9'>
          <button
            type='button'
            className='btn btn-light me-3'
            onClick={() => navigate(`/groupe-libpr/liste`)}
          >
            Annuler
          </button>
          <button type='submit' className='btn btn-primary'>
            {isLoading ? (
              <span className='indicator-progress' style={{display: 'block'}}>
                Enregistrement...{' '}
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              </span>
            ) : (
              'Enregistrer'
            )}
          </button>
        </div>
      </form>
    </div>
  )
}

export {GroupeLIBPRForm}
